import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import { gbp, fmtDate, ORDER_STATUS_LABELS } from '../lib/shop';
import { PageHead } from './components';

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/admin/dashboard').then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="h-40 bg-white animate-pulse border hairline" />;

  const cards = [
    ['Revenue', gbp(d.revenue), '/admin/payments', 'rev'],
    ['Orders', d.total_orders, '/admin/orders', 'orders'],
    ['Pending payments', d.pending_payments, '/admin/payments', 'pending'],
    ['Active products', d.products, '/admin/products', 'products'],
    ['Low / out of stock', d.low_stock, '/admin/inventory', 'stock'],
    ['Customers', d.customers, '/admin/customers', 'customers'],
    ['New messages', d.new_messages, '/admin/customers', 'messages'],
  ];

  return (
    <div data-testid="admin-dashboard">
      <PageHead title="Dashboard" sub="Live view of the VQ Health store." />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {cards.map(([label, value, to, tid]) => (
          <Link key={label} to={to} data-testid={`dash-card-${tid}`} className="bg-white border hairline p-5 hover:border-[#0B0F12] transition-colors">
            <p className="font-mono2 text-[10px] uppercase tracking-[0.18em] text-[#8A8F95]">{label}</p>
            <p className="font-display font-black text-3xl mt-1">{value}</p>
          </Link>
        ))}
      </div>

      <div className="mt-8 bg-white border hairline">
        <div className="flex items-center justify-between p-4 border-b hairline">
          <p className="font-display font-bold uppercase text-lg">Recent orders</p>
          <Link to="/admin/orders" className="font-mono2 text-[10px] uppercase tracking-widest text-[#575B60] hover:text-[#0B0F12]">View all</Link>
        </div>
        <table className="w-full text-sm">
          <tbody>
            {d.recent_orders.map((o) => (
              <tr key={o.id} className="border-b hairline last:border-0">
                <td className="p-3 font-mono2 font-semibold">{o.order_number}</td>
                <td className="p-3 text-[#575B60]">{o.customer_email}</td>
                <td className="p-3"><span className="font-mono2 text-[10px] uppercase tracking-wider border hairline px-2 py-1">{ORDER_STATUS_LABELS[o.status] || o.status}</span></td>
                <td className="p-3 font-mono2">{gbp(o.total)}</td>
                <td className="p-3 text-xs text-[#8A8F95]">{fmtDate(o.created_at)}</td>
              </tr>
            ))}
            {d.recent_orders.length === 0 && <tr><td className="p-6 text-center text-[#8A8F95]">No orders yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
